
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/fraud-prevention",
      function () {
        return require("private-next-pages/help/fraud-prevention/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/fraud-prevention"])
      });
    }
  